;(function($, undefined){

    var rnn = window.rnn,
        pollSelector = ".poll";



    /////////////////////
    // Show (or hide) view results link
    /////////////////////

    function showViewResultsLink($poll, show){
        if(show){
            $poll.find(".viewResults").show();
        }else{
            $poll.find(".viewResults").hide();
        }
    }

    function updateResultsLink($poll){
        var $pollViewResults = $poll.find('.viewResults'),
            $pollResults = $poll.find('.results');

        if($pollViewResults.length === 1){
            $pollViewResults.removeClass('viewResults').addClass('hideResults').html('Hide Results');
            $pollResults.show();
        }else{
            $poll.find('.hideResults').removeClass('hideResults').addClass('viewResults').html('View Results');
            $pollResults.hide();
        }
    }

    /////////////////////
    // Submit Poll
    /////////////////////

    function submitPoll($poll) {

        var $voteButton = $poll.find(".submit"),
            $form = $poll.find("form"),
            settings = $poll.data("pollsettings"),
            votes = [],
            formData;

        // Grey out vote button
        $voteButton.attr('disabled', 'disabled');

        $(':input', $form).each(function(){
            if (this.name === 'poll' && this.checked && this.value > 0) {
                votes.push(this.value);
            }
        });

        // Ensure an answer is selected
        if (!votes.length) {
            rnn.modules.alert.show($form, 'You have not selected an answer.', "Please select an answer");
            return;
        }

        // Ensure no more than the maximum number of votes have been selected
        if (votes.length > settings.maxchoices) {
            alert('You must not select more then '+ settings.maxchoices +'.');
            rnn.modules.alert.show($form, 'You must not select more then '+ settings.maxchoices +'.', "Too many answers");
            return;
        }

        formData = {'poll': votes, 'csrfmiddlewaretoken': settings.csrfToken};

        //Submit with valid poll data
        $.ajax({
            url: settings.submitUrl,
            type: "POST",
            data: formData,
            contentType: "application/x-www-form-urlencoded",
            success:function(){
                $form.hide();
                getResults($poll);
                $poll.find(".results").show().removeClass('results-border-top');
            },
            error: function(){
                alert('An error occurred when attempting to submit your vote');
                $voteButton.removeAttr('disabled');
            }
        });
    }

    /////////////////////
    // Get Results
    /////////////////////

    function getResults($poll) {
        var $results = $poll.closest('.textPoll').find(".results"),
            settings = $poll.data("pollsettings");

        $results.text('Retrieving results...');

        function pollResultCallback(response, status) {
            if (status === 'error') {

                // Clear the loading text
                $results.text('Sorry, we could not retrieve the results. Please try again later.');

                // Enable the vote button again
                showViewResultsLink($poll, true);
            }
        }

        // Place results in target
        $results.load(settings.resultsUrl + '?ajax=1 .pollResults', '', pollResultCallback);
        updateResultsLink($poll);
    }

    function resetChoices($photoGalleryPoll){
        var expanded = $photoGalleryPoll.find('.expanded');
        expanded.each(function(){
            var $choice = $(this),
                $thumbnail = $choice.find('.thumbnail');

            $choice.removeClass('expanded stickRight')
                .siblings().removeClass('opaque')
                .parent().siblings('.choices').children().removeClass('opaque');

            $thumbnail.attr('src', $thumbnail.data('thumbnail'));
        });
    }

    function positionChoice($choice){
        var $choices = $choice.closest('.choices');
            $choiceContent = $choice.find('.content'),
            photoGalleryPollWidth = $choices.width(),
            photoGalleryPollHeight = $choices.height(),
            choiceHeight = $choice.height(),
            choiceWidth = $choice.width(),
            choiceDetailsHeight = $choiceContent.height(),
            choicePosition = $choice.position(),
            topOfThumb = $choiceContent.offset().top,
            bottomOfThumb = topOfThumb + $choiceContent.outerHeight(),
            $window = $(window),
            windowScroll = $window.scrollTop(),
            windowScrollBottom = windowScroll + $window.height();

        if(Math.round(choicePosition.left) >= photoGalleryPollWidth / 2){
            $choice.addClass('stickRight');
        }

        // bottom row images need to expand upwards
        if($choices.next().hasClass('voteStatus')){
            $choice.find('.content').css({bottom: 0});
        }

        if(choicePosition.top + $choiceContent.position().top < 0){
            $choiceContent.css({bottom: "auto", top: 0 - choicePosition.top});
        }

        if(bottomOfThumb > windowScrollBottom){
            $window.scrollTop(
                $choiceContent.offset().top -
                $window.height() +
                choiceDetailsHeight +
                // the floating status box at the bottom's height, plus a bit of padding
                $choice.closest('.poll').find('.voteStatus').outerHeight() + 10
            );
        }

        if(topOfThumb < windowScroll){
            $window.scrollTop(topOfThumb);
        }
    }

    function initialisePhotoGalleryPoll($poll){
        $poll.on('change', 'form input[type="checkbox"], form input[type="radio"]', function(){
            var $photoGalleryPoll = $(this).closest('.photoGalleryPoll'),
                maxChoices = $photoGalleryPoll.data('pollsettings').maxchoices,
                $choicesCount = $photoGalleryPoll.find('.tally .numChoices'),
                $remainingCount = $photoGalleryPoll.find('.tally .remainingChoices'),
                $remainingCountVal,
                $remainingPlural = $photoGalleryPoll.find('.tally .plural'),
                $remainingPluralVal,
                $inputs = $photoGalleryPoll.find('form input[type="checkbox"]:checked, form input[type="radio"]:checked'),
                $allInputs = $photoGalleryPoll.find('form input[type="checkbox"], form input[type="radio"]'),
                $chosenIcons = $photoGalleryPoll.find('.chosenIcons').empty(); //This is slow. But thats what you get when you dont use a data driven front end framework :)

            $allInputs.siblings("label").html("Select<i class='tangram-icon icon-right icon-plus'></i>")
                .addClass('button-default-border').removeClass('button-default-dark')
                .closest('.content').find('.thumbnail').removeClass('selected');
            $inputs.siblings("label").html("Selected<i class='icomoon-icon icon-right icon-checkmark'></i>")
                .removeClass('button-default-border').addClass('button-default-dark')
                .closest('.content').find('.thumbnail').addClass('selected');

            $choicesCount.text($inputs.length);
            $remainingCountVal = maxChoices - $inputs.length;
            $remainingPluralVal = $remainingCountVal != 1 ? 's' : '';
            $remainingCount.text($remainingCountVal);
            $remainingPlural.text($remainingPluralVal);

            $inputs.each(function(){
                var $input = $(this),
                    chosenIcon = $(document.createElement('div')).addClass('chosenIcon'),
                    chosenImg = $(document.createElement('img')).attr('src', $input.closest('.choice').find('.thumbnail').data('icon')),
                    removeButton = $(document.createElement('span')).addClass('icon-cross');

                removeButton.on('click', function(){
                    $input.prop('checked',false).change();
                });
                $chosenIcons.append(chosenIcon.append(chosenImg, removeButton));
            });

            if(maxChoices - $inputs.length === 0){
                $('form input[type="checkbox"]:not(:checked), form input[type="option"]:not(:checked)').attr('disabled', 'disabled');
            }else{
                $('form input[type="checkbox"], form input[type="option"]').removeAttr('disabled');
            }
        });

        if(!rnn.site.isMobile){
            // for desktop
            $poll.on("click", ".expanded .content, .thumbnail", function(event){
                var $choice = $(event.target).closest('.choice'),
                    $photoGalleryPoll = $choice.closest('.photoGalleryPoll'),
                    $thumbnail;

                if($(event.target).is('input, label')){
                    return;
                }

                if(!$choice.is('.expanded')){
                    resetChoices($photoGalleryPoll);

                    $choice.addClass('expanded')
                        .siblings().addClass('opaque')
                        .parent().siblings('.choices').children().addClass('opaque');

                    positionChoice($choice);

                    $thumbnail = $choice.find('.thumbnail');
                    $thumbnail.attr('src', $thumbnail.data('fullsize'));

                }else{
                    resetChoices($photoGalleryPoll);
                }
            });
        }else{
            // for mobile
            $poll.on("click", ".expanded .content, .thumbnail", function(event){
                var $choice = $(event.target).closest('.choice'),
                    $photoGalleryPoll = $choice.closest('.photoGalleryPoll'),
                    $thumbnail;

                if($(event.target).is('input, label')){
                    return;
                }

                if(!$choice.is('.expanded')){
                    resetChoices($photoGalleryPoll);

                    $choice.addClass('expanded')
                        .siblings().addClass('opaque')
                        .parent().siblings('.choices').children().addClass('opaque');

                    positionChoice($choice);

                    $thumbnail = $choice.find('.thumbnail');
                    $thumbnail.attr('src', $thumbnail.data('fullsize'));
                }else{
                    resetChoices($photoGalleryPoll);
                }
            });
        }
    }

    /////////////////////
    // Initialise Polls
    /////////////////////
    function initPolls() {

        /* init event handlers */

        //Submit vote
        $(".poll:not(.photoGalleryPoll) form").on("submit", function(event){
            event.preventDefault();

            submitPoll($(this).closest(pollSelector));
        });

        //Show Results
        $(".poll .viewResults").on("click", function(event){
            var $poll = $(this).closest(pollSelector);

            event.preventDefault();

            getResults($poll);
        });

        $(".poll.photoGalleryPoll").each(function(){
            initialisePhotoGalleryPoll($(this));
        });
    }

    rnn.modules.register("polls", {
        init: initPolls
    });

})(jQuery);
